import { useTranslation } from 'react-i18next';
import { DeleteOutlined, FilterOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row, Select, Typography } from "antd";
import { viLocale as locale } from "../../../../../utils/pickerType";
import { FormInstance } from "antd/lib";
import dayjs from "dayjs";
import { FunctionComponent } from "react";
import "./FormFilter.scss";
import { get } from "lodash";
import { globalStore } from "../../../../../stores/stores";
import FormItemDropdown from "../../../../../components/form-dropdown/FormItemDropdown";

type FormFilterProps = {
  handleCloseFilter: () => void;
  tab: string;
  showFilter?: boolean;
  form: FormInstance;
  clearFilter: () => void;
  onFinish?: () => void;
  setFilterData?: (dateString: string[], planCreationDate: string) => void;
  dataOptions?: any;
  filterData: any;
  isMoreFilters?: boolean;
  hasSharer?: boolean;
  typeQuestion: boolean
  onFinishFilter?: (values: any) => void;

};

const FormFilter: FunctionComponent<FormFilterProps> = ({
  onFinish,
  tab,
  form,
  showFilter,
  dataOptions,
  clearFilter,
  setFilterData,
  typeQuestion,
  hasSharer = false,
  onFinishFilter
}) => {
  const { t } = useTranslation();
  const { RangePicker } = DatePicker;

  const handleDateChange = (dates: any) => {
    const dateRange = dates ? dates.map((date: any) => date) : [];
    setFilterData && setFilterData(dateRange, "createDate");
  };

  const handleFinish = (values: any) => {
    let convertedDates: string[] = [];
    if (values.updatedDate && values.updatedDate.length === 2) {
      const [startDayjs, endDayjs] = values.updatedDate;
      convertedDates = [
        startDayjs.format("YYYY-MM-DD"),
        endDayjs.format("YYYY-MM-DD"),
      ];
    }
    onFinishFilter && onFinishFilter({
      ...values,
      updatedDate: convertedDates,
    });
  };
  return (
    <>
      <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={handleFinish}>
          <Row
            gutter={[{ xs: 8, xl: 24, md: 16 }, 12]}
            className="pt-2 learning-material-filter"
          >
            <Col>
              <Typography.Title level={5}>{t("Chủ đề", "Chủ đề")}</Typography.Title>
              <Form.Item name="topics">
                <Select
                  placeholder={t("Chọn chủ đề", "Chọn chủ đề")}
                  onChange={(option) => setFilterData && setFilterData(option, "topics")}
                  options={get(dataOptions, 'dataTopic', '')}
                  mode="multiple"
                  allowClear
                />

              </Form.Item>
            </Col>
            {
              tab === "2" || hasSharer ?
                <>
                  <Col>
                    <Typography.Title level={5}>{t("Tác giả", "Tác giả")}</Typography.Title>
                    <Form.Item name="author">
                      <Select
                        placeholder={t("Người chia sẻ", "Người chia sẻ")}
                        onChange={(option) => setFilterData && setFilterData(option, "author")}
                        options={get(dataOptions, 'dataAuthor')}
                        mode="multiple"
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Typography.Title level={5}>{t("Đơn vị xuất bản", "Đơn vị xuất bản")}</Typography.Title>
                    <Form.Item name="unit">
                      <Select
                        placeholder={t("Chọn đơn vị xuất bản", "Chọn đơn vị xuất bản")}
                        onChange={(option) => setFilterData && setFilterData(option, "unit")}
                        options={get(dataOptions, 'dataUnit')}
                        mode="multiple"
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                </>
                :
                null
            }

            {typeQuestion &&
              <>
                <Col xl={{ span: 4 }} md={{ span: 5 }} sm={{ span: 5 }} xs={{ span: 24 }}>
                  <Typography.Title level={5}>{t("Phân cấp", "Phân cấp")}</Typography.Title>
                  <Form.Item name="level">
                    <FormItemDropdown
                      modeDropdown='multiple'
                      placeholder={t("Chọn phân cấp", "Chọn phân cấp")}
                      options={get(dataOptions, 'dataLevel')}
                    />
                  </Form.Item>
                </Col>
                <Col>
                  <Typography.Title level={5}>{t("Đơn vị xuất bản", "Đơn vị xuất bản")}</Typography.Title>
                  <Form.Item name="unit">
                    <Select
                      placeholder={t("Chọn đơn vị xuất bản", "Chọn đơn vị xuất bản")}
                      onChange={(option) => setFilterData && setFilterData(option, "unit")}
                      options={get(dataOptions, 'dataUnit')}
                      mode="multiple"
                      allowClear
                    />
                  </Form.Item>
                </Col>
              </>}


            <Col>
              <Typography.Title level={5}>{t("Ngày cập nhật", "Ngày cập nhật")}</Typography.Title>
              <Form.Item name="startDate">
                <RangePicker
                  placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                  format="DD-MM-YYYY"
                  style={{ width: "100%" }}
                  locale={locale}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                  onChange={handleDateChange}
                />
              </Form.Item>
            </Col>
            <Col style={{ display: "flex", alignItems: "flex-end" }}>
              <div style={{ display: "flex", gap: "12px" }}>
                <Button
                  className="btn btn-primary search-btn"
                  htmlType="submit"
                >
                  <FilterOutlined />
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={clearFilter}
                >
                  <DeleteOutlined />
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default FormFilter;
